var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpCabinetSliderArrowR(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 60,
    viewBox: "0 0 40 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 59,
    rx: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 40C15.2031 39.9999 14.9132 39.916 14.6665 39.7589C14.4199 39.6018 14.2277 39.3785 14.1142 39.1173C14.0007 38.8561 13.971 38.5686 14.0288 38.2913C14.0867 38.014 14.2295 37.7593 14.4392 37.5593L22.3791 29.9912L14.4392 22.4231C14.166 22.1535 14.0148 21.7923 14.0182 21.4174C14.0216 21.0425 14.1794 20.6839 14.4575 20.4188C14.7356 20.1537 15.1118 20.0033 15.5052 20.0001C15.8985 19.9968 16.2774 20.1409 16.5603 20.4014L25.5608 28.9803C25.842 29.2485 26 29.6121 26 29.9912C26 30.3704 25.842 30.734 25.5608 31.0021L16.5603 39.5811C16.2791 39.8492 15.8976 39.9999 15.4998 40Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpCabinetSliderArrowR);
export default __webpack_public_path__ + "static/media/lp_cabinet_slider_arrow_r.f533bb7fa46a99fdb2e3730630ed9c1a.svg";
export { ForwardRef as ReactComponent };